import { DatePicker, DatePickerProps as IDatePicker } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers'
import ruLocale from 'date-fns/locale/ru';
import { ruRU } from '@mui/x-date-pickers/locales';

/*
*   Обертка над DatePicker
*/


type IDesktopDatePickerCustom = {
    ruLocale?: Locale,
} & IDatePicker<any, any>


export function DesktopDatePickerCustom(props: IDesktopDatePickerCustom) {

    const localeMap: { [key: string]: { locale: Locale, mask: string, format: string } } = {
        ru: { locale: ruLocale, mask: '__.__.____', format: 'dd.MM.yyyy' },
    };

    const locale = localeMap['ru'];


    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={locale.locale}
            localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}
        >
            <DatePicker
                mask={locale.mask}
                inputFormat={locale.format}
                {...props}
                sx={{ width: '160px', ...(props.sx || {}) }}
            />
        </LocalizationProvider>

    );
}